import {
  State,
  ReducerActions,
  TotalItemsActions,
  PageSizeActions,
  CurrentPageActions,
} from './types';
import { limitPageBounds } from './meta';

const getCurrentPageReducer = (rootState: State) => (
  state: State['currentPage'],
  action: ReducerActions,
) => {
  switch (action.type) {
    case 'SET_PAGE':
      return limitPageBounds(
        rootState.totalItems,
        rootState.pageSize,
      )(action.page);
    case 'NEXT_PAGE':
      return limitPageBounds(
        rootState.totalItems,
        rootState.pageSize,
      )(state + 1);
    case 'PREVIOUS_PAGE':
      return limitPageBounds(
        rootState.totalItems,
        rootState.pageSize,
      )(state - 1);
    case 'SET_PAGE_SIZE':
      return limitPageBounds(
        rootState.totalItems,
        action.pageSize,
      )(action.nextPage ?? state);
    case 'SET_TOTAL_ITEMS':
      return limitPageBounds(
        action.totalItems,
        rootState.pageSize,
      )(action.nextPage ?? state);
    default:
      return state;
  }
};

const totalItemsReducer = (
  state: State['totalItems'],
  action: TotalItemsActions,
) => {
  switch (action.type) {
    case 'SET_TOTAL_ITEMS':
      return action.totalItems;
    default:
      return state;
  }
};

const pageSizeReducer = (state: State['pageSize'], action: PageSizeActions) => {
  switch (action.type) {
    case 'SET_PAGE_SIZE':
      return action.pageSize;
    default:
      return state;
  }
};

export const reducer = (state: State, action: ReducerActions): State => {
  return {
    currentPage: getCurrentPageReducer(state)(
      state.currentPage,
      action as CurrentPageActions,
    ),
    totalItems: totalItemsReducer(
      state.totalItems,
      action as TotalItemsActions,
    ),
    pageSize: pageSizeReducer(state.pageSize, action as PageSizeActions),
  };
};
